"use client";
import React, { useEffect, useRef, useState } from "react";
import { FmIcon } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import stl from "../productShowMore.module.scss";
import classnames from "classnames";
import { IProps } from ".";

interface IClientProps extends IProps {}

const ProductShowMoreClient: React.FC<React.PropsWithChildren<IClientProps>> = (
    props,
) => {
    const [isShow, setIsShow] = useState(!!props.isShow);
    const { t } = useTranslation("productDetail");
    const childrenRef = useRef<HTMLDivElement>(null);
    const showMoreRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (RegExp(/reviews/).exec(location.hash)) {
            let moreShow = childrenRef.current?.children[0];
            setTimeout(() => {
                if (moreShow) {
                    moreShow.scrollIntoView();
                    setTimeout(() => {
                        moreShow = showMoreRef.current?.children[0];
                        if (moreShow) {
                            moreShow.scrollIntoView({
                                behavior: "smooth",
                            });
                        }
                    }, 200);
                }
            }, 200);
            setIsShow(true);
        }
    }, []);

    const toggerShow = () => {
        setIsShow((prev) => !prev);
    };
    const { showHeight = "4rem" } = props;
    return (
        <>
            <div
                id="reviews-more-show"
                className={stl["more-show-container"]}
                style={{
                    height: !isShow ? showHeight : "unset",
                }}
            >
                <div className={stl["more-show-content"]} ref={childrenRef}>
                    {props.children}
                </div>
            </div>
            {!props.isShow && (
                <div
                    ref={showMoreRef}
                    className={classnames(stl["show-more-btn"], {
                        [stl["show-more-hide"]]: !isShow,
                    })}
                    onClick={toggerShow}
                >
                    {!isShow
                        ? t("productDetail:ShowMore")
                        : t("productDetail:ShowLess")}
                    <FmIcon
                        icon={isShow ? "icon--arrow-top" : "icon--arrow-down"}
                        className={stl["arrow-icon-class"]}
                    />
                </div>
            )}
        </>
    );
};

export default ProductShowMoreClient;
